import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import './InputWithButton.scss';

class InputWithButton extends React.Component {

    constructor(props, context) {
        super(props, context);
    }

    componentDidMount() {
        if (this.props.isFocused) {
            this.inputRef.focus();
        }

        if (this.props.isRequired) {
            this.inputRef.required = true;
        }
        if (this.props.pattern) {
            this.inputRef.pattern = this.props.pattern;
        }
    }

    onKeyDown = (e) => {
        if (e.keyCode === 13 && this.props.onButtonClick) {
            this.props.onButtonClick(e);
        }
    }

    render() {
        const Ref = (el) => (this.inputRef = el);
        const maxlen = this.props.maxLength ? this.props.maxLength : 100;

        return (
            <div className="input-with-button">
                <div className="input-group mb-3">
                    <input
                        className={this.props.isValid === false ? "form-control is-invalid" : "form-control"}
                        id={this.props.name}
                        name={this.props.name}
                        type={this.props.type}
                        placeholder={this.props.placeholder}
                        value={this.props.value}
                        onChange={this.props.onChange}
                        onFocus={this.props.onFocus}
                        onBlur={this.props.onBlur}
                        onKeyDown={this.onKeyDown}
                        disabled={this.props.isDisabled}
                        ref={Ref}
                        maxLength={maxlen}
                        autoComplete="off"
                    />
                    {this.props.showButton && (
                        <button
                            className="btn btn-outline-secondary"
                            type="button"
                            id={`${this.props.name}-button`}
                            onClick={this.props.onButtonClick}
                        >
                            <Icon name="arrow-right" />
                        </button>
                    )}
                </div>
                {this.props.errorMessage && (
                    <div className="invalid-feedback">{this.props.errorMessage}</div>
                )}
            </div>
        );
    }
}

InputWithButton.propTypes = {
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired, // text, email
    placeholder: PropTypes.string,
    value: PropTypes.string,
    errorMessage: PropTypes.string,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    isRequired: PropTypes.bool,
    pattern: PropTypes.string,
    isFocused: PropTypes.bool,
    isValid: PropTypes.bool,
    isDisabled: PropTypes.bool,
    bootstrapClass: PropTypes.string,
    maxLength: PropTypes.number,
    showButton: PropTypes.bool,
    onButtonClick: PropTypes.func,
};

export default InputWithButton;
